export default __webpack_public_path__ + "static/media/venify_logo.f05a76b4.png";